import React from 'react';
import { Modal, Button } from 'antd';

interface AuthErrorModalProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  message?: string;
  buttonText?: string;
  onOk?: () => void;
}

export const AuthErrorModal: React.FC<AuthErrorModalProps> = ({
  open,
  onClose,
  title = 'Authentication Error',
  message = 'An unexpected error occurred. Please try again.',
  buttonText = 'OK',
  onOk,
}) => {
  const handleOk = () => {
    if (onOk) {
      onOk();
    }
    onClose();
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      maskClosable
      width={420}
      className="auth-error-modal"
    >
      <div className="flex flex-col items-center text-center p-2 pt-4">
        {/* Error Icon Badge */}
        <div className="w-14 h-14 rounded-full bg-red-50 flex items-center justify-center mb-4 border border-red-100 shadow-sm">
          <svg
            width="28"
            height="28"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="10" stroke="#A91D22" strokeWidth="2" fill="#FEE2E2" />
            <path
              d="M12 7V13"
              stroke="#A91D22"
              strokeWidth="2.2"
              strokeLinecap="round"
            />
            <circle cx="12" cy="16.5" r="1.2" fill="#A91D22" />
          </svg>
        </div>

        {/* Title */}
        <h3 className="text-xl font-semibold text-gray-900 mb-2">
          {title}
        </h3>

        {/* Message */}
        <p className="text-sm text-gray-600 leading-relaxed mb-6 px-3">
          {message}
        </p>

        {/* Action Button */}
        <Button
          type="primary"
          size="large"
          onClick={handleOk}
          className="w-full h-11 text-base font-medium !bg-[#A91D22] hover:!bg-[#8a171b] !border-none rounded-lg shadow-sm transition-all flex items-center justify-center !text-white"
        >
          {buttonText}
        </Button>
      </div>
    </Modal>
  );
};

export default AuthErrorModal;
